import React, { useEffect, useState, useRef, useCallback } from 'react'
// import classNames from 'classnames'
import { Swiper as SwiperCore, Autoplay, EffectFade, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useInView } from 'react-intersection-observer'
// import useVisible from 'Components/hooks/use-visible'

import SwiperClass from 'swiper/types/swiper-class'
import { sendTeaAdEvent, sendAdMonitor } from 'lib/tea-analyze'
import { LS_AD } from 'Constants/link-source'
import { AD_RIT, EVENTID } from 'Constants/ad'
import styles from './index.module.scss'

SwiperCore.use([Autoplay, EffectFade, Pagination])

const eventIds = {
  ad_resource_filter_banner: 'filter_area_below_ad_banner',
  ad_resource_bottom_banner: 'bottom_ad_banner',
  ad_resource_detail_banner: 'above_similar_car_ad_banner',
}

const linkSources = {
  ad_resource_filter_banner:
    'dcd_pc_esc_used_car_source_list_filter_area_below_ad_banner',
  ad_resource_bottom_banner: 'dcd_pc_esc_used_car_source_list_bottom_ad_banner',
  ad_resource_detail_banner:
    'dcd_pc_esc_used_car_source_detail_above_similar_car_ad_banner',
}
enum BannerType {
  AD = 1000,
  SOURCE = 1001,
}
export type AdDataType = {
  ad_group_id_str: string
  ad_log_id: string
  ad_price_type: string
  convert_id: string
  id: number
  id_str: string
  image_left_big: {
    height: number
    url: string
    width: number
  }
  image_right_big: {
    height: number
    url: string
    width: number
  }
  log_extra: string
  materiel_id: string
  materiel_str: string
  rit: number
  rit_str: AD_RIT
  web_url: string
  track_url_list?: string[]
  click_track_url_list?: string[]
}
export type SourceData = {
  title: string
  left_image_url: string
  right_image_url: string
  open_url: string
  //资源位id
  widget_id: number
  // 计划id
  plan_id: number
  source_key:
    | 'ad_resource_filter_banner'
    | 'ad_resource_bottom_banner'
    | 'ad_resource_detail_banner'
}
interface IProps {
  tea?: {
    page_id?: string
    [key: string]: string | number | undefined
  }
  sourceDataWithAd?: {
    type: number
    info?: {
      resource_data?: SourceData
      raw_spread_data?: AdDataType
    }
  }[]
  hideCloseIcon?: boolean
  useSendEvent?: boolean
}

export default function BannerAdWithSource({
  tea,
  sourceDataWithAd = [],
  hideCloseIcon,
  useSendEvent,
}: IProps) {
  const [close, setClose] = useState<boolean>(false)

  const [activeIndex, setActiveIndex] = useState(0)
  const [swiper, setSwiper] = useState<SwiperClass>()

  const paginationRef = useRef<HTMLDivElement>(null)
  const [ref, inView] = useInView({
    threshold: 0,
  })
  const notSingle = sourceDataWithAd && sourceDataWithAd?.length > 1

  const getAdTeaParams = (adData: AdDataType) => {
    const params = {
      link_source: LS_AD[adData?.rit_str],
      is_ad: 1,
      ad_group_id: adData?.ad_group_id_str,
      ad_price_type: adData?.ad_price_type,
      ad_rit: adData?.rit_str,
      ad_material_id: adData?.materiel_str,
      ad_target_url: adData?.web_url,
      log_extra: adData?.log_extra,
      ad_id: adData?.id_str,
      ad_req_id: adData?.log_extra ? JSON.parse(adData?.log_extra).req_id : '',
    }
    // 如果希望自定义埋点数据，可以在props传参覆盖
    if (tea) {
      Object.assign(params, tea)
    }
    return params
  }
  // dislike关闭点击
  const handleCloseClick = (
    e: React.MouseEvent<HTMLSpanElement, MouseEvent>,
    adTeaParams: { [key: string]: string | number },
    rank = '0',
    adData: AdDataType
  ) => {
    e.stopPropagation()
    sendTeaAdEvent('ad_rt_dislike', {
      ...adTeaParams,
      rank,
      event_id: `${EVENTID[adData?.rit_str]}_close`,
    })
    setClose(true)
  }

  const sendAdClickEvent = useCallback(
    (
      adParams: { [key: string]: string | number },
      adData: AdDataType,
      custom = {}
    ) => {
      sendTeaAdEvent('ad_clk_event', {
        ...adParams,
        ...custom,
      })
      if (adData?.click_track_url_list) {
        adData.click_track_url_list.forEach((url) => {
          sendAdMonitor({
            url,
            requestId: adData?.ad_log_id,
            eventId: 'ad_clk_event',
          })
        })
      }
    },
    []
  )
  // banner点击跳转, rank 区分左右
  const handleAdClick = (adData: AdDataType) => {
    const { web_url, rit_str } = adData || {}
    // 增加link_source 为了线索归因
    const url = `${web_url}${web_url?.includes('?') ? '&' : '?'}link_source=${
      LS_AD[rit_str]
    }`

    setTimeout(() => {
      window.open(url, '_blank')
    }, 50)
  }
  const handleSourceClick =
    (sourceData: SourceData, carousel_rank: number, rank: string) => () => {
      sendTeaAdEvent('ad_clk_event', {
        ...tea,
        is_ad: 0,
        middleground_id: sourceData?.plan_id,
        resource_pos_id: sourceData?.widget_id,
        carousel_rank: carousel_rank + 1,
        rank,
        event_id: sourceData?.source_key
          ? eventIds[sourceData?.source_key]
          : '',
        link_source: sourceData?.source_key
          ? linkSources[sourceData?.source_key]
          : '',
      })

      setTimeout(() => {
        window.open(sourceData?.open_url, '_blank')
      }, 50)
    }

  useEffect(() => {
    sourceDataWithAd.forEach((it, index) => {
      if (it?.type === BannerType.AD && it?.info?.raw_spread_data) {
        // 按照约定下发埋点
        if (useSendEvent) {
          sendTeaAdEvent('ad_send_event', {
            ...getAdTeaParams(it?.info?.raw_spread_data),
            event_id: EVENTID[it.info.raw_spread_data.rit_str],
          })
        } else {
          // 广告下发埋点
          sendTeaAdEvent(
            `ad_send_${EVENTID[it?.info?.raw_spread_data?.rit_str]}`,
            {
              ...getAdTeaParams(it?.info?.raw_spread_data),
              carousel_rank: index + 1,
            }
          )
        }
      }
    })

    // 重新下发重置状态
    setClose(false)
  }, [sourceDataWithAd])

  useEffect(() => {
    if (!inView) {
      swiper?.autoplay?.stop()
      return
    }
    if (sourceDataWithAd?.length > 1) {
      swiper?.autoplay?.start()
    }

    if (sourceDataWithAd?.[activeIndex]?.type === BannerType.AD) {
      //广告埋点
      const info = sourceDataWithAd?.[activeIndex]?.info
        ?.raw_spread_data as AdDataType

      sendTeaAdEvent('ad_show_event', {
        ...getAdTeaParams(info),
        event_id: EVENTID[info?.rit_str],
        carousel_rank: activeIndex + 1,
      })

      if (info?.track_url_list) {
        info.track_url_list.forEach((url) => {
          sendAdMonitor({
            url,
            requestId: info?.ad_log_id,
            eventId: 'ad_show_event',
          })
        })
      }
      return
    }
    if (sourceDataWithAd?.[activeIndex]?.type === BannerType.SOURCE) {
      // 资源位，和广告用同一套埋点机制，参数不同
      const info = sourceDataWithAd?.[activeIndex]?.info?.resource_data
      sendTeaAdEvent('ad_show_event', {
        ...tea,
        is_ad: 0,
        middleground_id: info?.plan_id,
        resource_pos_id: info?.widget_id,
        carousel_rank: activeIndex + 1,
        event_id: info?.source_key ? eventIds[info?.source_key] : '',
        link_source: info?.source_key ? linkSources[info?.source_key] : '',
      })
    }
  }, [inView, activeIndex, sourceDataWithAd])

  const renderAd = (adData: AdDataType) => {
    const adParams = {
      ...getAdTeaParams(adData),
      event_id: EVENTID[adData?.rit_str],
    }
    return (
      <div className={styles['ad-row']}>
        <div
          className={styles['ad-banner']}
          onClick={() => {
            sendAdClickEvent(adParams, adData, { rank: '0' })
            handleAdClick(adData)
          }}
        >
          <img
            className={styles['baner-image']}
            src={adData?.image_left_big?.url}
            draggable={false}
          />
          <span className={styles['ad-text']}>广告</span>
          {!hideCloseIcon && (
            <span
              className={styles['icon-close']}
              onClick={(e) => {
                handleCloseClick(e, adParams, '0', adData)
              }}
              style={{
                backgroundImage: `url(${require('static/ad-close.png')})`,
              }}
            />
          )}
        </div>
        <div
          className={styles['ad-banner']}
          onClick={() => {
            sendAdClickEvent(adParams, adData, { rank: '1' })
            handleAdClick(adData)
          }}
        >
          <img
            className={styles['baner-image']}
            src={adData?.image_right_big?.url}
            draggable={false}
          />
          <span className={styles['ad-text']}>广告</span>
          {!hideCloseIcon && (
            <span
              className={styles['icon-close']}
              onClick={(e) => {
                handleCloseClick(e, adParams, '1', adData)
              }}
              style={{
                backgroundImage: `url(${require('static/ad-close.png')})`,
              }}
            />
          )}
        </div>
      </div>
    )
  }

  if (close) {
    return null
  }

  return (
    <div className={styles['wrap']} ref={ref}>
      <Swiper
        loop={notSingle}
        observer={true}
        resizeObserver={true}
        watchOverflow={true}
        speed={600}
        autoplay={notSingle ? { delay: 2000 } : false}
        onSwiper={setSwiper}
        onSlideChange={(swiper) => {
          const idx = swiper.realIndex
          setActiveIndex(idx)
        }}
        noSwiping={false}
        effect="fade"
        pagination={
          notSingle
            ? {
                el: paginationRef.current,
                clickable: true,
              }
            : false
        }
        fadeEffect={{ crossFade: true }}
      >
        {sourceDataWithAd?.map((item, index) => {
          if (item?.type === BannerType.AD) {
            //广告
            return (
              item?.info?.raw_spread_data && (
                <SwiperSlide key={index}>
                  {renderAd(item?.info?.raw_spread_data)}
                </SwiperSlide>
              )
            )
          }
          if (item?.type === BannerType.SOURCE) {
            const info = item?.info?.resource_data
            return (
              <SwiperSlide key={index}>
                <div className={styles['ad-row']}>
                  <div
                    className={styles['ad-banner']}
                    onClick={handleSourceClick(
                      item?.info?.resource_data as SourceData,
                      index,
                      '0'
                    )}
                  >
                    <img
                      className={styles['baner-image']}
                      src={info?.left_image_url}
                      draggable={false}
                    />
                  </div>
                  <div
                    className={styles['ad-banner']}
                    onClick={handleSourceClick(
                      item?.info?.resource_data as SourceData,
                      index,
                      '1'
                    )}
                  >
                    <img
                      className={styles['baner-image']}
                      src={info?.right_image_url}
                      draggable={false}
                    />
                  </div>
                </div>
              </SwiperSlide>
            )
          }
          return null
        })}
        {notSingle && (
          <div className={styles['pagination']} ref={paginationRef} />
        )}
      </Swiper>
    </div>
  )
}
